var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreVert = function SvgMoreVert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M11.204 5.205a1.125 1.125 0 1 1 1.592 1.59 1.125 1.125 0 0 1-1.591-1.59Zm0 6a1.125 1.125 0 1 1 1.591 1.59 1.125 1.125 0 0 1-1.59-1.59Zm0 6a1.125 1.125 0 1 1 1.591 1.59 1.125 1.125 0 0 1-1.59-1.59Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreVert);
export default ForwardRef;